import { type ISelectProps, Select } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type BudgetCategoryType } from '@webapp/models/enums/BudgetCategoryType'
import { useBudgetCategoryTypeOptions } from './hooks/useBudgetCategoryTypeOptions'
import messages from './messages'
import { BudgetCategoryTypeSelectStyled } from './styles/BudgetCategoryTypeSelectStyled'

export interface IBudgetCategoryTypeSelectProps
  extends ISelectProps<BudgetCategoryTypeOption> {
  defaultParam?: BudgetCategoryType
}

export interface BudgetCategoryTypeOption {
  label: string
  value: BudgetCategoryType
}

export const BudgetCategoryTypeSelect = ({
  defaultParam,
  ...props
}: IBudgetCategoryTypeSelectProps) => {
  const intl = useProcurifyIntl()
  const budgetCategoryTypeOptions = useBudgetCategoryTypeOptions()

  return (
    <BudgetCategoryTypeSelectStyled>
      <Select<BudgetCategoryTypeOption>
        placeholder={intl.formatMessage(
          messages.budgetCateogryTypeSelectPlaceholder
        )}
        options={budgetCategoryTypeOptions}
        getOptionValue={(option) => option.value}
        defaultValue={budgetCategoryTypeOptions.find(
          (option) => option.value === defaultParam
        )}
        {...props}
      />
    </BudgetCategoryTypeSelectStyled>
  )
}

BudgetCategoryTypeSelect.displayName = 'BudgetCategoryTypeSelect'
